<div class="shipping-information-container">
  <div class="shipping-information-name name-value-pair">
    <span class="label" translate>shipping-information.name</span>
    <span>{{ shippingInformation.name }}</span>
  </div>
  <div *ngIf="shippingInformation.companyName" class="shipping-information-company-name name-value-pair">
    <span class="label" translate>shipping-information.company-name</span>
    <span>{{ shippingInformation.companyName }}</span>
  </div>
  <vnm-email-address [email]="shippingInformation.email"></vnm-email-address>
  <vnm-phone-number [number]="shippingInformation.phoneNumber"></vnm-phone-number>
</div>
